import { render, staticRenderFns } from "./UsersTableMetrics.vue?vue&type=template&id=fead324a&scoped=true"
import script from "./UsersTableMetrics.vue?vue&type=script&lang=js"
export * from "./UsersTableMetrics.vue?vue&type=script&lang=js"
import style0 from "./UsersTableMetrics.vue?vue&type=style&index=0&id=fead324a&prod&scoped=true&lang=css"
import style1 from "./UsersTableMetrics.vue?vue&type=style&index=1&id=fead324a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fead324a",
  null
  
)

export default component.exports